export function routes($stateProvider) {

  $stateProvider
    .state('app.administration', {
      url: '/administration',
      abstract: true,
      template: '<ui-view></ui-view>'
    })
    .state('app.administration.logging', {
      url: '/logging',
      template: require('./logging/logging.view.html'),
      controller: 'LoggingController',
      controllerAs: 'vm',
      role: 'logging',
      params: {
        state: {
          value: 1,
          dynamic: true
        },
        page: {
          value: 1,
          dynamic: true
        },
        items: {
          value: 50,
          dynamic: true
        },
        order: {
          value: "id",
          dynamic: true
        },
        sort: {
          value: "desc",
          dynamic: true
        },
        filter: {
          dynamic: true
        }
      }
    })
    .state('app.administration.main', {
      url: '/',
      template: require('./main/main.view.html'),
      controller: 'ManagementController',
      controllerAs: 'vm',
      role: 'controlPanel'
    })
    .state('app.administration.system', {
      url: '/system',
      template: require('./system/system.view.html'),
      controller: 'SystemController',
      controllerAs: 'vm',
      role: 'systemInfo'
    })
    .state('app.administration.users', {
      url: '/users',
      abstract: true,
      template: '<ui-view></ui-view>'
    })
    .state('app.administration.users.add', {
      url: '/add',
      template: require('./main/users/add/add.view.html'),
      controller: 'UserAdminController',
      controllerAs: 'vm',
      role: 'usersAdd'
    })
    .state('app.administration.users.edit', {
      url: '/edit/:id',
      template: require('./main/users/edit/edit.view.html'),
      controller: 'UserEditAdminController',
      controllerAs: 'vm',
      role: 'usersEdit'
    })
    .state('app.administration.roles', {
      url: '/roles',
      abstract: true,
      template: '<ui-view></ui-view>'
    })
    .state('app.administration.roles.edit', {
      url: '/edit/:id',
      template: require('./main/roles/edit/edit.view.html'),
      controller: 'RoleEditController',
      controllerAs: 'vm',
      role: 'rolesEdit'
    })
    .state('app.administration.roles.add', {
      url: '/add',
      template: require('./main/roles/add/add.view.html'),
      controller: 'RoleAddController',
      controllerAs: 'vm',
      role: 'rolesAdd'
    })
    .state('app.administration.configParametros', {
      url:'/config_parametros',
      title: 'Administração - Configuração de Parâmetros',
      template: require('./config_parametros/config.view.html'),
      controller: 'ConfigParametrosController',
      controllerAs: 'vm',
      role: 'configurarParametros'
    })

  ;
}

routes.$inject = ['$stateProvider'];
